import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import addWeeks from 'date-fns/addWeeks';
import { View, Views } from 'react-big-calendar';

export type CalendarNavigationDirection = 'previous' | 'next';

export const getAdjacentCalendarDate = (
    date: Date,
    view: View,
    direction: CalendarNavigationDirection,
) => {
    const amount = direction === 'next' ? 1 : -1;

    switch (view) {
        case Views.DAY:
            return addDays(date, amount);
        case Views.WEEK:
            return addWeeks(date, amount);
        case Views.AGENDA:
        case Views.MONTH:
        default:
            return addMonths(date, amount);
    }
};
